// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3xAVG","header":"PatientQuestionnaire_header__3n8YJ","info":"PatientQuestionnaire_info__30GFV"};